import { render, staticRenderFns } from "./videoAi.vue?vue&type=template&id=576d2fc7&scoped=true"
import script from "./videoAi.vue?vue&type=script&lang=js"
export * from "./videoAi.vue?vue&type=script&lang=js"
import style0 from "./videoAi.vue?vue&type=style&index=0&id=576d2fc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576d2fc7",
  null
  
)

export default component.exports